import React, { useState, useEffect } from 'react';
import zxcvbn from 'zxcvbn';

const PasswordStrengthMeter = ({ password, firstName = '', lastName = '' }) => {
    const [strength, setStrength] = useState(0);
    const [validations, setValidations] = useState({
        length: false,
        upperCase: false,
        number: false,
        specialChar: false,
        noName: false
    });

    useEffect(() => {
        if (!password) {
            setStrength(0);
            return;
        }

        const result = zxcvbn(password);
        setStrength(result.score);
    
        // Trim & normalize inputs for case-insensitive matching
        const lowerPassword = password.toLowerCase().trim();
        const lowerFirst = firstName?.toLowerCase().trim() || "";
        const lowerLast = lastName?.toLowerCase().trim() || "";
    
        // console.log(`Lower Password: '${lowerPassword}'`);
        // console.log(`Lower First Name: '${lowerFirst}'`);
        // console.log(`Lower Last Name: '${lowerLast}'`);
    
        const isFirstNameValid = lowerFirst.length > 2;
        const isLastNameValid = lowerLast.length > 2;
    
        // **Check name detection**
        const containsFirstName = isFirstNameValid && lowerPassword.includes(lowerFirst);
        const containsLastName = isLastNameValid && lowerPassword.includes(lowerLast);
        const containsFullName = isFirstNameValid && isLastNameValid && lowerPassword.includes(lowerFirst + lowerLast);
        const isJustName = lowerPassword === lowerFirst || lowerPassword === lowerLast || lowerPassword === (lowerFirst + lowerLast);
    
        // console.log(`Contains First Name? ${containsFirstName}`);
        // console.log(`Contains Last Name? ${containsLastName}`);
        // console.log(`Contains Full Name? ${containsFullName}`);
        // console.log(`Is Just Name? ${isJustName}`);
    
        // **Check if validation is working correctly**
        const noNameCheck = !(containsFirstName || containsLastName || containsFullName || isJustName);
        // console.log(`noName Validation (should be false if name is inside password): ${noNameCheck}`);
    
        setValidations({
            length: password.length >= 12,
            upperCase: /[A-Z]/.test(password),
            number: /\d/.test(password),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            noName: noNameCheck
        });
    
    }, [password, firstName, lastName]);

    // Strength bar color based on score
    const getColor = () => {
        switch (strength) {
            case 0: return 'gray';
            case 1: return 'red';
            case 2: return 'orange';
            case 3: return 'blue';
            case 4: return 'green';
            default: return 'gray';
        }
    };

    return (
        <div style={{ width: '100%', marginTop: '10px' }}>
            {/* Strength Bar (Hidden when password is empty) */}
            {password && (
                <div style={{
                    height: '8px',
                    width: `${(strength + 1) * 20}%`,
                    backgroundColor: getColor(),
                    transition: 'width 0.3s ease-in-out',
                    borderRadius: '5px'
                }}></div>
            )}

            {/* Validation List (Only Show When Typing) */}
            {password && (
                <ul style={{ listStyleType: 'none', padding: 0, marginTop: '10px', fontSize: '14px' }}>
                    <li style={{ color: validations.length ? 'green' : 'red' }}>
                        {validations.length ? '✔' : '✖'} At least 12 characters
                    </li>
                    <li style={{ color: validations.upperCase ? 'green' : 'red' }}>
                        {validations.upperCase ? '✔' : '✖'} At least one uppercase letter
                    </li>
                    <li style={{ color: validations.number ? 'green' : 'red' }}>
                        {validations.number ? '✔' : '✖'} At least one number
                    </li>
                    <li style={{ color: validations.specialChar ? 'green' : 'red' }}>
                        {validations.specialChar ? '✔' : '✖'} At least one special character
                    </li>
                    <li style={{ color: validations.noName ? 'green' : 'red' }}>
                        {validations.noName ? '✔' : '✖'} Cannot contain your first or last name or be just your name
                    </li>
                </ul>
            )}
        </div>
    );
};

export default PasswordStrengthMeter;